import Header from "../components/Header"
import LanguageSet from "../components/language/LanguageSet"
import LanguageContext from "../components/hooks/LanguageContext"
import { useContext, useEffect, useState } from "react"
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Constants from "../common/Constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { Modal } from "react-bootstrap";
import { useAuth } from "../providers/AuthProvider";
import { getText } from "../utils/languageUtils";

const API_CERTIFICATE = `${Constants.BASE_URL}/appcertificate`;
const API_STUDENT_PROGRESS = `${Constants.BASE_URL}/studentprogress`;

const Certificate = () => {
    const { user, logout: authLogout, authDispatch } = useAuth();
    const { language, translations: translationData } = useContext(LanguageContext);
    const translations = translationData?.certificate || {};
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [module, setModule] = useState(null)
    const [showInst, setShowInst] = useState(true);

    const handleClose = () => setShowInst(false);

    useEffect(() => {

        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await axios.post(`${API_CERTIFICATE}?access_token=${user?.token}`);

                if (response.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                } else {
                    setModule(response.data)
                }
                setLoading(false)
            } catch (error) {
                // console.error(error);
                setLoading(false)
            }
        }
        fetchData();
    }, [user?.token]);

    useEffect(() => {
        setLoading(true)
        let newUrl = `${API_STUDENT_PROGRESS}?access_token=${user?.token}`
        axios.post(newUrl).then((response) => {
            if (response.data.message === "Invalid Access Token") {
                authLogout()
                navigate("/");
            } else {
                const progress = response.data?.student_summary;
                authDispatch({ type: "SET_PROGRESS", payload: { points: progress.points, progress } });
                setLoading(false);
            }
        }).catch((err) => {
            console.error(err)
            setLoading(false)
        });
    }, [])

    return (
        <>
            <div id="body_bg">
                <Header page_title={getText(translations.certificate, language)} />
                <LanguageSet />
                <div className="container-fluid px-0">
                    <div className="row justify-content-center">
                        <div className="col-xl-5 col-md-12">
                            <section className="my-3">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12">
                                            {module?.certificate_summary?.certificate_status === true &&
                                                <>
                                                    <div className="sectionsBox"><p className="mb-0 text-center">{getText(translations.certificate, language)}</p>

                                                    </div>
                                                    <div className="annoucemnet_bx mb-2 mt-5">
                                                        <div className="row">
                                                            <div className="col-8 d-flex justify-content-between align-items-center">
                                                                <a className="leftannou ms-5" style={{ textDecorationColor: "#2f4672" }} href={`${Constants.BASE_URL}${module.certificate_summary.pdf}`} target='_blank' rel='noopener noreferrer'>
                                                                    <p className="mb-0" style={{ color: "#2f4672" }}>{getText(translations.download, language)}</p>
                                                                </a>
                                                            </div>
                                                            <div className="col-4  align-items-end d-flex justify-content-end ">
                                                                <div className="rightannou">
                                                                    <a href={`${Constants.BASE_URL}${module.certificate_summary.pdf}`} target='_blank' download rel="noreferrer" className="me-5">
                                                                        <FontAwesomeIcon icon={faDownload} size="sm" color="#002859" />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                            {module?.certificate_summary?.certificate_status === false && <div className="" style={{ minHeight: "150px" }}>

                                                <p className="mb-0 text-center">
                                                    {getText(module?.certificate_summary?.common_message, language)}
                                                </p>
                                                <Modal show={showInst} onHide={handleClose}
                                                    aria-labelledby="contained-modal-title-vcenter"
                                                    centered
                                                >
                                                    <Modal.Body>
                                                        {getText(module?.certificate_summary?.common_message, language)}
                                                    </Modal.Body>
                                                </Modal>
                                            </div>
                                            }

                                        </div>
                                    </div>

                                </div>
                            </section>
                        </div>
                    </div>
                </div >
            </div >
        </>
    )
}

export default Certificate